// client/src/api/restaurantes.js
import api from "./config.js";

// Convertir objeto restaurante a FormData
const toFormData = (restaurante) => {
  const formData = new FormData();
  
  for (const key in restaurante) {
    if (key === "id_restaurante") continue;
    
    const value = restaurante[key];
    if (value !== undefined && value !== null && value !== "") {
      if (key === "logo" || key === "portada") {
        if (value instanceof File) {
          formData.append(key, value);
        }
      } else {
        formData.append(key, value);
      }
    }
  }
  
  return formData;
};


// Obtener todos los restaurantes
export const getRestaurantes = async () => {
  const { data } = await api.get("/restaurantes");
  return data; // { message, restaurantes }
};

// Obtener restaurante por ID
export const getRestaurante = async (id) => {
  const { data } = await api.get(`/restaurantes/${id}`);
  return data;
};

// Crear restaurante
export const createRestaurante = async (restaurante) => {
  const formData = toFormData(restaurante);
  const { data } = await api.post("/restaurantes", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

// Actualizar restaurante
export const updateRestaurante = async (id, restaurante) => {
  const formData = toFormData(restaurante);
  const { data } = await api.put(`/restaurantes/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

// Eliminar restaurante
export const deleteRestaurante = async (id) => {
  const { data } = await api.delete(`/restaurantes/${id}`);
  return data;
};

// Cambiar estado del restaurante (activo/inactivo)
export const changeEstadoRestaurante = async (id, estado) => {
  const { data } = await api.patch(`/restaurantes/${id}/estado`, { estado });
  return data;
};
